
import css from 'styled-jsx/css';

export default css`.search__field-input-wrap {
  position: absolute;
  right: 0;
  left: 0;
  bottom: -120%;
  opacity: 0;
  pointer-events: none;
  transition: opacity 300ms;
}

.search__field-input-wrap--open {
  opacity: 1;
  pointer-events: all;
}

.search__field-input-wrap :global(.search-icon) {
  position: absolute;
  pointer-events: none;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
}

.search__field-input {
  border: 2px solid #000000;
  border-radius: 30px;
  padding: 6px 10px;
  width: 100%;
  height: 37px;
  -webkit-appearance: textfield;
}

.search__field-input:focus {
  outline: none;
}

.search__opener {
  border: 2px solid #000000;
  border-radius: 30px;
  padding: 6px;
  width: 37px;
  height: 37px;
  cursor: pointer;

  :global(svg) {
    position: relative;
    top: 1px;
    left: 1px;
  }
}

.search__opener--open {
  background: black;

  :global(path),
  :global(circle) {
    stroke: white;
  }
}

@media (min-width: 665px) {
  .search__opener {
    display: none;
  }

  .search__field-input-wrap {
    position: static;
    opacity: 1;
    pointer-events: all;
    bottom: 0;
    left: auto;
    right: auto;
  }
}

@media (min-width: 990px) {
  .search__field-input-wrap {
    width: 100%;
  }
}
`